// extracted by mini-css-extract-plugin
export default {"wrapper":"Video_wrapper__d4wIz","player":"Video_player__6crYW"};